/**
 * Calculate payment due, total savings, and if savings are greater than the original invoice cost.
 * If savings are greater than the original invoice cost, paymentDue will be set to 0.
 *
 * @param {number} originalInvoiceCost - The original invoice cost in dollars.
 * @param {number[]} includedExamsValues - An array of included exam values in dollars.
 * @returns {{
 *   savings: number,
 *   savingsGreaterThanCost: boolean,
 *   paymentDue: number
 * }} An object containing the total savings, if the savings are greater than the original invoice cost, and the payment due.
 */

export function calculatePaymentDue(originalInvoiceCost, includedExamsValues) {
  // Calculate the total savings based on the included exams values
  const savings = !!includedExamsValues?.length ? includedExamsValues.reduce((prev, next) => prev + next) : 0;

  // Convert original invoice cost and savings to cents to avoid floating point errors
  const originalInvoiceCostCents = Math.round(originalInvoiceCost * 100);
  const savingsCents = Math.round(savings * 100);

  // Determine if savings are greater than the original invoice cost
  const savingsGreaterThanCost = savingsCents > originalInvoiceCostCents;

  // Calculate the payment due in cents
  const paymentDueCents = Math.max(0, originalInvoiceCostCents - savingsCents); // Add Math.max() to ensure paymentDueCents is not negative

  // Convert payment due back to dollars
  const paymentDue = paymentDueCents / 100;

  return {
    savings,
    savingsGreaterThanCost,
    paymentDue,
  };
}
